require('./newsletter');
require('./cookies');
require('./contact');
require('./form-230');
require('./dots');
require('./slider');
require('./offer-request-lead-widget');
require('./tour-bookings');
require('./products');
require('./tickets');
require('./bookings');
require('./gallery');
require('./form');
require('./search');
require('./property_view');
require('./login');
require('./companies');
require('./account');
require('./user-favorites');
require('./island_view');
require('./art_view');
require('./vehicle_view');
require('./darkmode');
require('./carousel-double');
require('./form/index');


// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js